(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2418"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2418"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2AvH9", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("24WJr")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("9Ddln")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("24WJr")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("d6CNR")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("nsqlv")).createPopper; });

var $cEoCh = parcelRequire("cEoCh");

var $1Esf5 = parcelRequire("1Esf5");

var $24WJr = parcelRequire("24WJr");
var $9Ddln = parcelRequire("9Ddln");

var $d6CNR = parcelRequire("d6CNR");

var $nsqlv = parcelRequire("nsqlv");
$parcel$exportWildcard(module.exports, $cEoCh);
$parcel$exportWildcard(module.exports, $1Esf5);

});
parcelRegister("cEoCh", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $935c50c8659545b7$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $935c50c8659545b7$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $935c50c8659545b7$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $935c50c8659545b7$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $935c50c8659545b7$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $935c50c8659545b7$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $935c50c8659545b7$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $935c50c8659545b7$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $935c50c8659545b7$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $935c50c8659545b7$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $935c50c8659545b7$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $935c50c8659545b7$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $935c50c8659545b7$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $935c50c8659545b7$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $935c50c8659545b7$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $935c50c8659545b7$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $935c50c8659545b7$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $935c50c8659545b7$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $935c50c8659545b7$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $935c50c8659545b7$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $935c50c8659545b7$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $935c50c8659545b7$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $935c50c8659545b7$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $935c50c8659545b7$export$d087d3878fdf71d5; });
var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];

});

parcelRegister("1Esf5", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("4dG9Q")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("2P8UZ")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("xcXwJ")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("lsNQz")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("iMl36")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("aKE1P")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("c8CJF")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("ksntq")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("6blW5")).default; });

var $4dG9Q = parcelRequire("4dG9Q");

var $2P8UZ = parcelRequire("2P8UZ");

var $xcXwJ = parcelRequire("xcXwJ");

var $lsNQz = parcelRequire("lsNQz");

var $iMl36 = parcelRequire("iMl36");

var $aKE1P = parcelRequire("aKE1P");

var $c8CJF = parcelRequire("c8CJF");

var $ksntq = parcelRequire("ksntq");

var $6blW5 = parcelRequire("6blW5");

});
parcelRegister("4dG9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $312913fa2edc14b2$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");
// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $9ghG1.isHTMLElement)(element) || !(0, $1DgzM.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $9ghG1.isHTMLElement)(element) || !(0, $1DgzM.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("1DgzM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13064aa41dd611dc$export$2e2bcd8739ae039; });
function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("9ghG1", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $6be351e83d6bf643$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $6be351e83d6bf643$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $6be351e83d6bf643$export$af51f0f06c0f328a; });

var $3s2ws = parcelRequire("3s2ws");
function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $3s2ws.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $3s2ws.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $3s2ws.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("3s2ws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2835f189066da699$export$2e2bcd8739ae039; });
function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("2P8UZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20e743289f291887$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $eQTzt = parcelRequire("eQTzt");

var $1yHmV = parcelRequire("1yHmV");

var $5jKxG = parcelRequire("5jKxG");

var $3m9cx = parcelRequire("3m9cx");

var $6Q9NZ = parcelRequire("6Q9NZ");

var $VHjvt = parcelRequire("VHjvt");

var $jxLne = parcelRequire("jxLne");

var $cEoCh = parcelRequire("cEoCh");
var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $VHjvt.default)(typeof padding !== 'number' ? padding : (0, $jxLne.default)(padding, (0, $cEoCh.basePlacements)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $8MGgd.default)(state.placement);
    var axis = (0, $3m9cx.default)(basePlacement);
    var isVertical = [
        (0, $cEoCh.left),
        (0, $cEoCh.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $eQTzt.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cEoCh.top) : (0, $cEoCh.left);
    var maxProp = axis === 'y' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5jKxG.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $6Q9NZ.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $1yHmV.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("8MGgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6653967f933aaf29$export$2e2bcd8739ae039; });

function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("eQTzt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad01075005a54bff$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");
function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2mYUo.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("2mYUo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b9ce20ada6267ed$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");

var $c79oh = parcelRequire("c79oh");

var $3s2ws = parcelRequire("3s2ws");

var $fvb08 = parcelRequire("fvb08");
function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $9ghG1.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $c79oh.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $c79oh.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $9ghG1.isElement)(element) ? (0, $3s2ws.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fvb08.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("c79oh", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $8d1d6c453d67c9ab$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $8d1d6c453d67c9ab$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $8d1d6c453d67c9ab$export$2077e0241d6afd3c; });
var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("fvb08", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b49248e188a52b8b$export$2e2bcd8739ae039; });

var $cTNvd = parcelRequire("cTNvd");
function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cTNvd.default)());
}

});
parcelRegister("cTNvd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9641053f99441231$export$2e2bcd8739ae039; });
function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("1yHmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $122a9b90bb37fc73$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");
function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $9ghG1.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("5jKxG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3df2d470c30a409e$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");

var $1DgzM = parcelRequire("1DgzM");

var $3lU8c = parcelRequire("3lU8c");

var $9ghG1 = parcelRequire("9ghG1");

var $3pGhD = parcelRequire("3pGhD");

var $gBzyr = parcelRequire("gBzyr");

var $cTNvd = parcelRequire("cTNvd");
function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $9ghG1.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3lU8c.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cTNvd.default)());
    var isIE = /Trident/i.test((0, $cTNvd.default)());
    if (isIE && (0, $9ghG1.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3lU8c.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $gBzyr.default)(element);
    if ((0, $9ghG1.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $9ghG1.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $1DgzM.default)(currentNode)) < 0){
        var css = (0, $3lU8c.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $3s2ws.default)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $3pGhD.default)(offsetParent) && (0, $3lU8c.default)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1DgzM.default)(offsetParent) === 'html' || (0, $1DgzM.default)(offsetParent) === 'body' && (0, $3lU8c.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}

});
parcelRegister("3lU8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $270edfbc2bfbd22f$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $3s2ws.default)(element).getComputedStyle(element);
}

});

parcelRegister("3pGhD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27c48183f07ddbe8$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");
function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $1DgzM.default)(element)) >= 0;
}

});

parcelRegister("gBzyr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c16bae6800ecc025$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");

var $4NPk2 = parcelRequire("4NPk2");

var $9ghG1 = parcelRequire("9ghG1");
function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $1DgzM.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $9ghG1.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4NPk2.default)(element) // fallback
    );
}

});
parcelRegister("4NPk2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37f38c85c1edad4d$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");
function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $9ghG1.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("3m9cx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $271a905a3adf884c$export$2e2bcd8739ae039; });
function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("6Q9NZ", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $4faf3481d1df2f95$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $4faf3481d1df2f95$export$86c8af6d3ef0b4a; });

var $c79oh = parcelRequire("c79oh");
function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $c79oh.max)(min, (0, $c79oh.min)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("VHjvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ad6ec2b432662d8$export$2e2bcd8739ae039; });

var $83sLw = parcelRequire("83sLw");
function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $83sLw.default)(), paddingObject);
}

});
parcelRegister("83sLw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dd4eac14cb3a9cb$export$2e2bcd8739ae039; });
function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("jxLne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a5d8ce75f76756$export$2e2bcd8739ae039; });
function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("xcXwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $063d2297888fea12$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $5jKxG = parcelRequire("5jKxG");

var $3s2ws = parcelRequire("3s2ws");

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $8MGgd = parcelRequire("8MGgd");

var $8Opre = parcelRequire("8Opre");

var $c79oh = parcelRequire("c79oh");
var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $c79oh.round)(x * dpr) / dpr || 0,
        y: (0, $c79oh.round)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cEoCh.left);
    var sideY = (0, $cEoCh.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5jKxG.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $3s2ws.default)(popper)) {
            offsetParent = (0, $4NPk2.default)(popper);
            if ((0, $3lU8c.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cEoCh.top) || (placement === (0, $cEoCh.left) || placement === (0, $cEoCh.right)) && variation === (0, $cEoCh.end)) {
            sideY = (0, $cEoCh.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cEoCh.left) || (placement === (0, $cEoCh.top) || placement === (0, $cEoCh.bottom)) && variation === (0, $cEoCh.end)) {
            sideX = (0, $cEoCh.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $3s2ws.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $8MGgd.default)(state.placement),
        variation: (0, $8Opre.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};

});
parcelRegister("8Opre", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66a6b9b7896d6ec4$export$2e2bcd8739ae039; });
function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("lsNQz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa02e10eb4995658$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $3s2ws.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};

});

parcelRegister("iMl36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dabd09962ff7b702$export$2e2bcd8739ae039; });

var $ivINy = parcelRequire("ivINy");

var $8MGgd = parcelRequire("8MGgd");

var $7Bece = parcelRequire("7Bece");

var $9Ddln = parcelRequire("9Ddln");

var $gnuPI = parcelRequire("gnuPI");

var $cEoCh = parcelRequire("cEoCh");

var $8Opre = parcelRequire("8Opre");
function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $8MGgd.default)(placement) === (0, $cEoCh.auto)) return [];
    var oppositePlacement = (0, $ivINy.default)(placement);
    return [
        (0, $7Bece.default)(placement),
        oppositePlacement,
        (0, $7Bece.default)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $8MGgd.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $ivINy.default)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $8MGgd.default)(placement) === (0, $cEoCh.auto) ? (0, $gnuPI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $8MGgd.default)(placement);
        var isStartVariation = (0, $8Opre.default)(placement) === (0, $cEoCh.start);
        var isVertical = [
            (0, $cEoCh.top),
            (0, $cEoCh.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9Ddln.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cEoCh.right) : (0, $cEoCh.left) : isStartVariation ? (0, $cEoCh.bottom) : (0, $cEoCh.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $ivINy.default)(mainVariationSide);
        var altVariationSide = (0, $ivINy.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("ivINy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d79ddf39683d3f91$export$2e2bcd8739ae039; });
var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}

});

parcelRegister("7Bece", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5887002dcefa0743$export$2e2bcd8739ae039; });
var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}

});

parcelRegister("9Ddln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70321b611e132ecc$export$2e2bcd8739ae039; });

var $cHqSr = parcelRequire("cHqSr");

var $4NPk2 = parcelRequire("4NPk2");

var $2mYUo = parcelRequire("2mYUo");

var $6OVAc = parcelRequire("6OVAc");

var $2tr8P = parcelRequire("2tr8P");

var $cEoCh = parcelRequire("cEoCh");

var $9ghG1 = parcelRequire("9ghG1");

var $VHjvt = parcelRequire("VHjvt");

var $jxLne = parcelRequire("jxLne");
function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cEoCh.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cEoCh.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cEoCh.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $VHjvt.default)(typeof padding !== 'number' ? padding : (0, $jxLne.default)(padding, (0, $cEoCh.basePlacements)));
    var altContext = elementContext === (0, $cEoCh.popper) ? (0, $cEoCh.reference) : (0, $cEoCh.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $cHqSr.default)((0, $9ghG1.isElement)(element) ? element : element.contextElement || (0, $4NPk2.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2mYUo.default)(state.elements.reference);
    var popperOffsets = (0, $6OVAc.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2tr8P.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cEoCh.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cEoCh.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cEoCh.right),
                (0, $cEoCh.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cEoCh.top),
                (0, $cEoCh.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("cHqSr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93ee5964b4e9d426$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $aMU0E = parcelRequire("aMU0E");

var $eHRAH = parcelRequire("eHRAH");

var $3yaXD = parcelRequire("3yaXD");

var $5jKxG = parcelRequire("5jKxG");

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $9ghG1 = parcelRequire("9ghG1");

var $2mYUo = parcelRequire("2mYUo");

var $gBzyr = parcelRequire("gBzyr");

var $1yHmV = parcelRequire("1yHmV");

var $1DgzM = parcelRequire("1DgzM");

var $2tr8P = parcelRequire("2tr8P");

var $c79oh = parcelRequire("c79oh");
function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2mYUo.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cEoCh.viewport) ? (0, $2tr8P.default)((0, $aMU0E.default)(element, strategy)) : (0, $9ghG1.isElement)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2tr8P.default)((0, $eHRAH.default)((0, $4NPk2.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $3yaXD.default)((0, $gBzyr.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3lU8c.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $9ghG1.isHTMLElement)(element) ? (0, $5jKxG.default)(element) : element;
    if (!(0, $9ghG1.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $9ghG1.isElement)(clippingParent) && (0, $1yHmV.default)(clippingParent, clipperElement) && (0, $1DgzM.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $c79oh.max)(rect.top, accRect.top);
        accRect.right = (0, $c79oh.min)(rect.right, accRect.right);
        accRect.bottom = (0, $c79oh.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $c79oh.max)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("aMU0E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7da9d5689cacb0a6$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");

var $4NPk2 = parcelRequire("4NPk2");

var $k1Xeb = parcelRequire("k1Xeb");

var $fvb08 = parcelRequire("fvb08");
function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $3s2ws.default)(element);
    var html = (0, $4NPk2.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fvb08.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $k1Xeb.default)(element),
        y: y
    };
}

});
parcelRegister("k1Xeb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e951d80a0194865c$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");

var $4NPk2 = parcelRequire("4NPk2");

var $VtlZ3 = parcelRequire("VtlZ3");
function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2mYUo.default)((0, $4NPk2.default)(element)).left + (0, $VtlZ3.default)(element).scrollLeft;
}

});
parcelRegister("VtlZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0acc17feb41c51bd$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $3s2ws.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("eHRAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab4ea6dd03061fae$export$2e2bcd8739ae039; });

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $k1Xeb = parcelRequire("k1Xeb");

var $VtlZ3 = parcelRequire("VtlZ3");

var $c79oh = parcelRequire("c79oh");
function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4NPk2.default)(element);
    var winScroll = (0, $VtlZ3.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $c79oh.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $c79oh.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $k1Xeb.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3lU8c.default)(body || html).direction === 'rtl') x += (0, $c79oh.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("3yaXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $295d0ca7e8ef250a$export$2e2bcd8739ae039; });

var $gScKu = parcelRequire("gScKu");

var $gBzyr = parcelRequire("gBzyr");

var $3s2ws = parcelRequire("3s2ws");

var $d5v3T = parcelRequire("d5v3T");
function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $gScKu.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $3s2ws.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $d5v3T.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $gBzyr.default)(target)));
}

});
parcelRegister("gScKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c48b941fd834c962$export$2e2bcd8739ae039; });

var $gBzyr = parcelRequire("gBzyr");

var $d5v3T = parcelRequire("d5v3T");

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");
function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $1DgzM.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $9ghG1.isHTMLElement)(node) && (0, $d5v3T.default)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $gBzyr.default)(node));
}

});
parcelRegister("d5v3T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9873d63ab8539814$export$2e2bcd8739ae039; });

var $3lU8c = parcelRequire("3lU8c");
function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3lU8c.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("2tr8P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cd357ee33805adc$export$2e2bcd8739ae039; });
function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("6OVAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f7414566eeea71a$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $8Opre = parcelRequire("8Opre");

var $3m9cx = parcelRequire("3m9cx");

var $cEoCh = parcelRequire("cEoCh");
function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $8MGgd.default)(placement) : null;
    var variation = placement ? (0, $8Opre.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cEoCh.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cEoCh.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cEoCh.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cEoCh.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $3m9cx.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cEoCh.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cEoCh.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("gnuPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bec6b628c79c2a3d$export$2e2bcd8739ae039; });

var $8Opre = parcelRequire("8Opre");

var $cEoCh = parcelRequire("cEoCh");

var $9Ddln = parcelRequire("9Ddln");

var $8MGgd = parcelRequire("8MGgd");
function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cEoCh.placements) : _options$allowedAutoP;
    var variation = (0, $8Opre.default)(placement);
    var placements = variation ? flipVariations ? (0, $cEoCh.variationPlacements) : (0, $cEoCh.variationPlacements).filter(function(placement) {
        return (0, $8Opre.default)(placement) === variation;
    }) : (0, $cEoCh.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9Ddln.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $8MGgd.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("aKE1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d3d400f3b7c97f3$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $9Ddln = parcelRequire("9Ddln");
function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cEoCh.top),
        (0, $cEoCh.right),
        (0, $cEoCh.bottom),
        (0, $cEoCh.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9Ddln.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9Ddln.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};

});

parcelRegister("c8CJF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d644778f0e020f0$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $cEoCh = parcelRequire("cEoCh");
function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $8MGgd.default)(placement);
    var invertDistance = [
        (0, $cEoCh.left),
        (0, $cEoCh.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cEoCh.left),
        (0, $cEoCh.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cEoCh.placements).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};

});

parcelRegister("ksntq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee48a1861d343976$export$2e2bcd8739ae039; });

var $6OVAc = parcelRequire("6OVAc");
function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $6OVAc.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};

});

parcelRegister("6blW5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4804c92787f86449$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $8MGgd = parcelRequire("8MGgd");

var $3m9cx = parcelRequire("3m9cx");

var $jVRdk = parcelRequire("jVRdk");

var $6Q9NZ = parcelRequire("6Q9NZ");

var $eQTzt = parcelRequire("eQTzt");

var $5jKxG = parcelRequire("5jKxG");

var $9Ddln = parcelRequire("9Ddln");

var $8Opre = parcelRequire("8Opre");

var $83sLw = parcelRequire("83sLw");

var $c79oh = parcelRequire("c79oh");
function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9Ddln.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $8MGgd.default)(state.placement);
    var variation = (0, $8Opre.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $3m9cx.default)(basePlacement);
    var altAxis = (0, $jVRdk.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cEoCh.top) : (0, $cEoCh.left);
        var altSide = mainAxis === 'y' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cEoCh.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cEoCh.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $eQTzt.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $83sLw.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $6Q9NZ.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5jKxG.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $6Q9NZ.within)(tether ? (0, $c79oh.min)(min, tetherMin) : min, offset, tether ? (0, $c79oh.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cEoCh.top) : (0, $cEoCh.left);
        var _altSide = mainAxis === 'x' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cEoCh.top),
            (0, $cEoCh.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $6Q9NZ.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $6Q9NZ.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("jVRdk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82c9e5baaa8e9af$export$2e2bcd8739ae039; });
function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("24WJr", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $1839837374f95732$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $1839837374f95732$export$8f7491d57c8f97a9; });

var $f7rEH = parcelRequire("f7rEH");

var $eQTzt = parcelRequire("eQTzt");

var $3yaXD = parcelRequire("3yaXD");

var $5jKxG = parcelRequire("5jKxG");

var $5XeBn = parcelRequire("5XeBn");

var $9n6Ia = parcelRequire("9n6Ia");

var $b7Gje = parcelRequire("b7Gje");

var $9Ddln = parcelRequire("9Ddln");

var $9ghG1 = parcelRequire("9ghG1");
var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $9ghG1.isElement)(reference) ? (0, $3yaXD.default)(reference) : reference.contextElement ? (0, $3yaXD.default)(reference.contextElement) : [],
                    popper: (0, $3yaXD.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $5XeBn.default)((0, $b7Gje.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $f7rEH.default)(reference, (0, $5jKxG.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $eQTzt.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9n6Ia.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("f7rEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b01cf64433a5b37b$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");

var $fIrSM = parcelRequire("fIrSM");

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");

var $k1Xeb = parcelRequire("k1Xeb");

var $4NPk2 = parcelRequire("4NPk2");

var $d5v3T = parcelRequire("d5v3T");

var $c79oh = parcelRequire("c79oh");
function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $c79oh.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $c79oh.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $9ghG1.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $9ghG1.isHTMLElement)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $4NPk2.default)(offsetParent);
    var rect = (0, $2mYUo.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1DgzM.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $d5v3T.default)(documentElement)) scroll = (0, $fIrSM.default)(offsetParent);
        if ((0, $9ghG1.isHTMLElement)(offsetParent)) {
            offsets = (0, $2mYUo.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $k1Xeb.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("fIrSM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b71097fc0b0e5f5c$export$2e2bcd8739ae039; });

var $VtlZ3 = parcelRequire("VtlZ3");

var $3s2ws = parcelRequire("3s2ws");

var $9ghG1 = parcelRequire("9ghG1");

var $hbsCN = parcelRequire("hbsCN");
function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $3s2ws.default)(node) || !(0, $9ghG1.isHTMLElement)(node)) return (0, $VtlZ3.default)(node);
    else return (0, $hbsCN.default)(node);
}

});
parcelRegister("hbsCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c829ab0279467772$export$2e2bcd8739ae039; });
function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("5XeBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $455dca0e08f2a815$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");
function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $cEoCh.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("9n6Ia", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d2b77c34ff005f5$export$2e2bcd8739ae039; });
function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("b7Gje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81912adbd60ec5c0$export$2e2bcd8739ae039; });
function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("d6CNR", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $98a9ef6d31ff03cd$export$8f7491d57c8f97a9; });

var $24WJr = parcelRequire("24WJr");

var $lsNQz = parcelRequire("lsNQz");

var $ksntq = parcelRequire("ksntq");

var $xcXwJ = parcelRequire("xcXwJ");

var $4dG9Q = parcelRequire("4dG9Q");

var $c8CJF = parcelRequire("c8CJF");

var $iMl36 = parcelRequire("iMl36");

var $6blW5 = parcelRequire("6blW5");

var $2P8UZ = parcelRequire("2P8UZ");

var $aKE1P = parcelRequire("aKE1P");


var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $lsNQz.default),
    (0, $ksntq.default),
    (0, $xcXwJ.default),
    (0, $4dG9Q.default),
    (0, $c8CJF.default),
    (0, $iMl36.default),
    (0, $6blW5.default),
    (0, $2P8UZ.default),
    (0, $aKE1P.default)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $24WJr.popperGenerator)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("nsqlv", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $0468327f9101fb67$export$8f7491d57c8f97a9; });

var $24WJr = parcelRequire("24WJr");

var $lsNQz = parcelRequire("lsNQz");

var $ksntq = parcelRequire("ksntq");

var $xcXwJ = parcelRequire("xcXwJ");

var $4dG9Q = parcelRequire("4dG9Q");
var $0468327f9101fb67$export$d34966752335dd47 = [
    (0, $lsNQz.default),
    (0, $ksntq.default),
    (0, $xcXwJ.default),
    (0, $4dG9Q.default)
];
var $0468327f9101fb67$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $24WJr.popperGenerator)({
    defaultModifiers: $0468327f9101fb67$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


var $2cb9d40d44afcdc0$exports = {};
/*!
  * Bootstrap v5.3.6 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
!function(t, e) {
    $2cb9d40d44afcdc0$exports = e((parcelRequire("2AvH9")));
}($2cb9d40d44afcdc0$exports, function(t) {
    "use strict";
    function e(t) {
        const e = Object.create(null, {
            [Symbol.toStringTag]: {
                value: "Module"
            }
        });
        if (t) {
            for(const i in t)if ("default" !== i) {
                const s = Object.getOwnPropertyDescriptor(t, i);
                Object.defineProperty(e, i, s.get ? s : {
                    enumerable: !0,
                    get: ()=>t[i]
                });
            }
        }
        return e.default = t, Object.freeze(e);
    }
    const i = e(t), s = new Map, n = {
        set (t, e, i) {
            s.has(t) || s.set(t, new Map);
            const n = s.get(t);
            n.has(e) || 0 === n.size ? n.set(e, i) : console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`);
        },
        get: (t, e)=>s.has(t) && s.get(t).get(e) || null,
        remove (t, e) {
            if (!s.has(t)) return;
            const i = s.get(t);
            i.delete(e), 0 === i.size && s.delete(t);
        }
    }, o = "transitionend", r = (t)=>(t && window.CSS && window.CSS.escape && (t = t.replace(/#([^\s"#']+)/g, (t, e)=>`#${CSS.escape(e)}`)), t), a = (t)=>{
        t.dispatchEvent(new Event(o));
    }, l = (t)=>!(!t || "object" != typeof t) && (void 0 !== t.jquery && (t = t[0]), void 0 !== t.nodeType), c = (t)=>l(t) ? t.jquery ? t[0] : t : "string" == typeof t && t.length > 0 ? document.querySelector(r(t)) : null, h = (t)=>{
        if (!l(t) || 0 === t.getClientRects().length) return !1;
        const e = "visible" === getComputedStyle(t).getPropertyValue("visibility"), i = t.closest("details:not([open])");
        if (!i) return e;
        if (i !== t) {
            const e = t.closest("summary");
            if (e && e.parentNode !== i) return !1;
            if (null === e) return !1;
        }
        return e;
    }, d = (t)=>!t || t.nodeType !== Node.ELEMENT_NODE || !!t.classList.contains("disabled") || (void 0 !== t.disabled ? t.disabled : t.hasAttribute("disabled") && "false" !== t.getAttribute("disabled")), u = (t)=>{
        if (!document.documentElement.attachShadow) return null;
        if ("function" == typeof t.getRootNode) {
            const e = t.getRootNode();
            return e instanceof ShadowRoot ? e : null;
        }
        return t instanceof ShadowRoot ? t : t.parentNode ? u(t.parentNode) : null;
    }, _ = ()=>{}, g = (t)=>{
        t.offsetHeight;
    }, f = ()=>window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, m = [], p = ()=>"rtl" === document.documentElement.dir, b = (t)=>{
        var e;
        e = ()=>{
            const e = f();
            if (e) {
                const i = t.NAME, s = e.fn[i];
                e.fn[i] = t.jQueryInterface, e.fn[i].Constructor = t, e.fn[i].noConflict = ()=>(e.fn[i] = s, t.jQueryInterface);
            }
        }, "loading" === document.readyState ? (m.length || document.addEventListener("DOMContentLoaded", ()=>{
            for (const t of m)t();
        }), m.push(e)) : e();
    }, v = (t, e = [], i = t)=>"function" == typeof t ? t.call(...e) : i, y = (t, e, i = !0)=>{
        if (!i) return void v(t);
        const s = ((t)=>{
            if (!t) return 0;
            let { transitionDuration: e, transitionDelay: i } = window.getComputedStyle(t);
            const s = Number.parseFloat(e), n = Number.parseFloat(i);
            return s || n ? (e = e.split(",")[0], i = i.split(",")[0], 1e3 * (Number.parseFloat(e) + Number.parseFloat(i))) : 0;
        })(e) + 5;
        let n = !1;
        const r = ({ target: i })=>{
            i === e && (n = !0, e.removeEventListener(o, r), v(t));
        };
        e.addEventListener(o, r), setTimeout(()=>{
            n || a(e);
        }, s);
    }, w = (t, e, i, s)=>{
        const n = t.length;
        let o = t.indexOf(e);
        return -1 === o ? !i && s ? t[n - 1] : t[0] : (o += i ? 1 : -1, s && (o = (o + n) % n), t[Math.max(0, Math.min(o, n - 1))]);
    }, A = /[^.]*(?=\..*)\.|.*/, E = /\..*/, C = /::\d+$/, T = {};
    let k = 1;
    const $ = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    }, S = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    function L(t, e) {
        return e && `${e}::${k++}` || t.uidEvent || k++;
    }
    function O(t) {
        const e = L(t);
        return t.uidEvent = e, T[e] = T[e] || {}, T[e];
    }
    function I(t, e, i = null) {
        return Object.values(t).find((t)=>t.callable === e && t.delegationSelector === i);
    }
    function D(t, e, i) {
        const s = "string" == typeof e, n = s ? i : e || i;
        let o = M(t);
        return S.has(o) || (o = t), [
            s,
            n,
            o
        ];
    }
    function N(t, e, i, s, n) {
        if ("string" != typeof e || !t) return;
        let [o, r, a] = D(e, i, s);
        if (e in $) {
            const t = (t)=>function(e) {
                    if (!e.relatedTarget || e.relatedTarget !== e.delegateTarget && !e.delegateTarget.contains(e.relatedTarget)) return t.call(this, e);
                };
            r = t(r);
        }
        const l = O(t), c = l[a] || (l[a] = {}), h = I(c, r, o ? i : null);
        if (h) return void (h.oneOff = h.oneOff && n);
        const d = L(r, e.replace(A, "")), u = o ? function(t, e, i) {
            return function s(n) {
                const o = t.querySelectorAll(e);
                for(let { target: r } = n; r && r !== this; r = r.parentNode)for (const a of o)if (a === r) return F(n, {
                    delegateTarget: r
                }), s.oneOff && j.off(t, n.type, e, i), i.apply(r, [
                    n
                ]);
            };
        }(t, i, r) : function(t, e) {
            return function i(s) {
                return F(s, {
                    delegateTarget: t
                }), i.oneOff && j.off(t, s.type, e), e.apply(t, [
                    s
                ]);
            };
        }(t, r);
        u.delegationSelector = o ? i : null, u.callable = r, u.oneOff = n, u.uidEvent = d, c[d] = u, t.addEventListener(a, u, o);
    }
    function P(t, e, i, s, n) {
        const o = I(e[i], s, n);
        o && (t.removeEventListener(i, o, Boolean(n)), delete e[i][o.uidEvent]);
    }
    function x(t, e, i, s) {
        const n = e[i] || {};
        for (const [o, r] of Object.entries(n))o.includes(s) && P(t, e, i, r.callable, r.delegationSelector);
    }
    function M(t) {
        return t = t.replace(E, ""), $[t] || t;
    }
    const j = {
        on (t, e, i, s) {
            N(t, e, i, s, !1);
        },
        one (t, e, i, s) {
            N(t, e, i, s, !0);
        },
        off (t, e, i, s) {
            if ("string" != typeof e || !t) return;
            const [n, o, r] = D(e, i, s), a = r !== e, l = O(t), c = l[r] || {}, h = e.startsWith(".");
            if (void 0 === o) {
                if (h) for (const i of Object.keys(l))x(t, l, i, e.slice(1));
                for (const [i, s] of Object.entries(c)){
                    const n = i.replace(C, "");
                    a && !e.includes(n) || P(t, l, r, s.callable, s.delegationSelector);
                }
            } else {
                if (!Object.keys(c).length) return;
                P(t, l, r, o, n ? i : null);
            }
        },
        trigger (t, e, i) {
            if ("string" != typeof e || !t) return null;
            const s = f();
            let n = null, o = !0, r = !0, a = !1;
            e !== M(e) && s && (n = s.Event(e, i), s(t).trigger(n), o = !n.isPropagationStopped(), r = !n.isImmediatePropagationStopped(), a = n.isDefaultPrevented());
            const l = F(new Event(e, {
                bubbles: o,
                cancelable: !0
            }), i);
            return a && l.preventDefault(), r && t.dispatchEvent(l), l.defaultPrevented && n && n.preventDefault(), l;
        }
    };
    function F(t, e = {}) {
        for (const [i, s] of Object.entries(e))try {
            t[i] = s;
        } catch (e) {
            Object.defineProperty(t, i, {
                configurable: !0,
                get: ()=>s
            });
        }
        return t;
    }
    function z(t) {
        if ("true" === t) return !0;
        if ("false" === t) return !1;
        if (t === Number(t).toString()) return Number(t);
        if ("" === t || "null" === t) return null;
        if ("string" != typeof t) return t;
        try {
            return JSON.parse(decodeURIComponent(t));
        } catch (e) {
            return t;
        }
    }
    function H(t) {
        return t.replace(/[A-Z]/g, (t)=>`-${t.toLowerCase()}`);
    }
    const B = {
        setDataAttribute (t, e, i) {
            t.setAttribute(`data-bs-${H(e)}`, i);
        },
        removeDataAttribute (t, e) {
            t.removeAttribute(`data-bs-${H(e)}`);
        },
        getDataAttributes (t) {
            if (!t) return {};
            const e = {}, i = Object.keys(t.dataset).filter((t)=>t.startsWith("bs") && !t.startsWith("bsConfig"));
            for (const s of i){
                let i = s.replace(/^bs/, "");
                i = i.charAt(0).toLowerCase() + i.slice(1), e[i] = z(t.dataset[s]);
            }
            return e;
        },
        getDataAttribute: (t, e)=>z(t.getAttribute(`data-bs-${H(e)}`))
    };
    class q {
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(t) {
            return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
        }
        _configAfterMerge(t) {
            return t;
        }
        _mergeConfigObj(t, e) {
            const i = l(e) ? B.getDataAttribute(e, "config") : {};
            return {
                ...this.constructor.Default,
                ..."object" == typeof i ? i : {},
                ...l(e) ? B.getDataAttributes(e) : {},
                ..."object" == typeof t ? t : {}
            };
        }
        _typeCheckConfig(t, e = this.constructor.DefaultType) {
            for (const [s, n] of Object.entries(e)){
                const e = t[s], o = l(e) ? "element" : null == (i = e) ? `${i}` : Object.prototype.toString.call(i).match(/\s([a-z]+)/i)[1].toLowerCase();
                if (!new RegExp(n).test(o)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${s}" provided type "${o}" but expected type "${n}".`);
            }
            var i;
        }
    }
    class W extends q {
        constructor(t, e){
            super(), (t = c(t)) && (this._element = t, this._config = this._getConfig(e), n.set(this._element, this.constructor.DATA_KEY, this));
        }
        dispose() {
            n.remove(this._element, this.constructor.DATA_KEY), j.off(this._element, this.constructor.EVENT_KEY);
            for (const t of Object.getOwnPropertyNames(this))this[t] = null;
        }
        _queueCallback(t, e, i = !0) {
            y(t, e, i);
        }
        _getConfig(t) {
            return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
        }
        static getInstance(t) {
            return n.get(c(t), this.DATA_KEY);
        }
        static getOrCreateInstance(t, e = {}) {
            return this.getInstance(t) || new this(t, "object" == typeof e ? e : null);
        }
        static get VERSION() {
            return "5.3.6";
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(t) {
            return `${t}${this.EVENT_KEY}`;
        }
    }
    const R = (t)=>{
        let e = t.getAttribute("data-bs-target");
        if (!e || "#" === e) {
            let i = t.getAttribute("href");
            if (!i || !i.includes("#") && !i.startsWith(".")) return null;
            i.includes("#") && !i.startsWith("#") && (i = `#${i.split("#")[1]}`), e = i && "#" !== i ? i.trim() : null;
        }
        return e ? e.split(",").map((t)=>r(t)).join(",") : null;
    }, K = {
        find: (t, e = document.documentElement)=>[].concat(...Element.prototype.querySelectorAll.call(e, t)),
        findOne: (t, e = document.documentElement)=>Element.prototype.querySelector.call(e, t),
        children: (t, e)=>[].concat(...t.children).filter((t)=>t.matches(e)),
        parents (t, e) {
            const i = [];
            let s = t.parentNode.closest(e);
            for(; s;)i.push(s), s = s.parentNode.closest(e);
            return i;
        },
        prev (t, e) {
            let i = t.previousElementSibling;
            for(; i;){
                if (i.matches(e)) return [
                    i
                ];
                i = i.previousElementSibling;
            }
            return [];
        },
        next (t, e) {
            let i = t.nextElementSibling;
            for(; i;){
                if (i.matches(e)) return [
                    i
                ];
                i = i.nextElementSibling;
            }
            return [];
        },
        focusableChildren (t) {
            const e = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map((t)=>`${t}:not([tabindex^="-"])`).join(",");
            return this.find(e, t).filter((t)=>!d(t) && h(t));
        },
        getSelectorFromElement (t) {
            const e = R(t);
            return e && K.findOne(e) ? e : null;
        },
        getElementFromSelector (t) {
            const e = R(t);
            return e ? K.findOne(e) : null;
        },
        getMultipleElementsFromSelector (t) {
            const e = R(t);
            return e ? K.find(e) : [];
        }
    }, V = (t, e = "hide")=>{
        const i = `click.dismiss${t.EVENT_KEY}`, s = t.NAME;
        j.on(document, i, `[data-bs-dismiss="${s}"]`, function(i) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName) && i.preventDefault(), d(this)) return;
            const n = K.getElementFromSelector(this) || this.closest(`.${s}`);
            t.getOrCreateInstance(n)[e]();
        });
    }, Q = ".bs.alert", X = `close${Q}`, Y = `closed${Q}`;
    class U extends W {
        static get NAME() {
            return "alert";
        }
        close() {
            if (j.trigger(this._element, X).defaultPrevented) return;
            this._element.classList.remove("show");
            const t = this._element.classList.contains("fade");
            this._queueCallback(()=>this._destroyElement(), this._element, t);
        }
        _destroyElement() {
            this._element.remove(), j.trigger(this._element, Y), this.dispose();
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = U.getOrCreateInstance(this);
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t](this);
                }
            });
        }
    }
    V(U, "close"), b(U);
    const G = '[data-bs-toggle="button"]';
    class J extends W {
        static get NAME() {
            return "button";
        }
        toggle() {
            this._element.setAttribute("aria-pressed", this._element.classList.toggle("active"));
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = J.getOrCreateInstance(this);
                "toggle" === t && e[t]();
            });
        }
    }
    j.on(document, "click.bs.button.data-api", G, (t)=>{
        t.preventDefault();
        const e = t.target.closest(G);
        J.getOrCreateInstance(e).toggle();
    }), b(J);
    const Z = ".bs.swipe", tt = `touchstart${Z}`, et = `touchmove${Z}`, it = `touchend${Z}`, st = `pointerdown${Z}`, nt = `pointerup${Z}`, ot = {
        endCallback: null,
        leftCallback: null,
        rightCallback: null
    }, rt = {
        endCallback: "(function|null)",
        leftCallback: "(function|null)",
        rightCallback: "(function|null)"
    };
    class at extends q {
        constructor(t, e){
            super(), this._element = t, t && at.isSupported() && (this._config = this._getConfig(e), this._deltaX = 0, this._supportPointerEvents = Boolean(window.PointerEvent), this._initEvents());
        }
        static get Default() {
            return ot;
        }
        static get DefaultType() {
            return rt;
        }
        static get NAME() {
            return "swipe";
        }
        dispose() {
            j.off(this._element, Z);
        }
        _start(t) {
            this._supportPointerEvents ? this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX) : this._deltaX = t.touches[0].clientX;
        }
        _end(t) {
            this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX - this._deltaX), this._handleSwipe(), v(this._config.endCallback);
        }
        _move(t) {
            this._deltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this._deltaX;
        }
        _handleSwipe() {
            const t = Math.abs(this._deltaX);
            if (t <= 40) return;
            const e = t / this._deltaX;
            this._deltaX = 0, e && v(e > 0 ? this._config.rightCallback : this._config.leftCallback);
        }
        _initEvents() {
            this._supportPointerEvents ? (j.on(this._element, st, (t)=>this._start(t)), j.on(this._element, nt, (t)=>this._end(t)), this._element.classList.add("pointer-event")) : (j.on(this._element, tt, (t)=>this._start(t)), j.on(this._element, et, (t)=>this._move(t)), j.on(this._element, it, (t)=>this._end(t)));
        }
        _eventIsPointerPenTouch(t) {
            return this._supportPointerEvents && ("pen" === t.pointerType || "touch" === t.pointerType);
        }
        static isSupported() {
            return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
        }
    }
    const lt = ".bs.carousel", ct = ".data-api", ht = "ArrowLeft", dt = "ArrowRight", ut = "next", _t = "prev", gt = "left", ft = "right", mt = `slide${lt}`, pt = `slid${lt}`, bt = `keydown${lt}`, vt = `mouseenter${lt}`, yt = `mouseleave${lt}`, wt = `dragstart${lt}`, At = `load${lt}${ct}`, Et = `click${lt}${ct}`, Ct = "carousel", Tt = "active", kt = ".active", $t = ".carousel-item", St = kt + $t, Lt = {
        [ht]: ft,
        [dt]: gt
    }, Ot = {
        interval: 5e3,
        keyboard: !0,
        pause: "hover",
        ride: !1,
        touch: !0,
        wrap: !0
    }, It = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        pause: "(string|boolean)",
        ride: "(boolean|string)",
        touch: "boolean",
        wrap: "boolean"
    };
    class Dt extends W {
        constructor(t, e){
            super(t, e), this._interval = null, this._activeElement = null, this._isSliding = !1, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = K.findOne(".carousel-indicators", this._element), this._addEventListeners(), this._config.ride === Ct && this.cycle();
        }
        static get Default() {
            return Ot;
        }
        static get DefaultType() {
            return It;
        }
        static get NAME() {
            return "carousel";
        }
        next() {
            this._slide(ut);
        }
        nextWhenVisible() {
            !document.hidden && h(this._element) && this.next();
        }
        prev() {
            this._slide(_t);
        }
        pause() {
            this._isSliding && a(this._element), this._clearInterval();
        }
        cycle() {
            this._clearInterval(), this._updateInterval(), this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
        }
        _maybeEnableCycle() {
            this._config.ride && (this._isSliding ? j.one(this._element, pt, ()=>this.cycle()) : this.cycle());
        }
        to(t) {
            const e = this._getItems();
            if (t > e.length - 1 || t < 0) return;
            if (this._isSliding) return void j.one(this._element, pt, ()=>this.to(t));
            const i = this._getItemIndex(this._getActive());
            if (i === t) return;
            const s = t > i ? ut : _t;
            this._slide(s, e[t]);
        }
        dispose() {
            this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
        }
        _configAfterMerge(t) {
            return t.defaultInterval = t.interval, t;
        }
        _addEventListeners() {
            this._config.keyboard && j.on(this._element, bt, (t)=>this._keydown(t)), "hover" === this._config.pause && (j.on(this._element, vt, ()=>this.pause()), j.on(this._element, yt, ()=>this._maybeEnableCycle())), this._config.touch && at.isSupported() && this._addTouchEventListeners();
        }
        _addTouchEventListeners() {
            for (const t of K.find(".carousel-item img", this._element))j.on(t, wt, (t)=>t.preventDefault());
            const t = {
                leftCallback: ()=>this._slide(this._directionToOrder(gt)),
                rightCallback: ()=>this._slide(this._directionToOrder(ft)),
                endCallback: ()=>{
                    "hover" === this._config.pause && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), 500 + this._config.interval));
                }
            };
            this._swipeHelper = new at(this._element, t);
        }
        _keydown(t) {
            if (/input|textarea/i.test(t.target.tagName)) return;
            const e = Lt[t.key];
            e && (t.preventDefault(), this._slide(this._directionToOrder(e)));
        }
        _getItemIndex(t) {
            return this._getItems().indexOf(t);
        }
        _setActiveIndicatorElement(t) {
            if (!this._indicatorsElement) return;
            const e = K.findOne(kt, this._indicatorsElement);
            e.classList.remove(Tt), e.removeAttribute("aria-current");
            const i = K.findOne(`[data-bs-slide-to="${t}"]`, this._indicatorsElement);
            i && (i.classList.add(Tt), i.setAttribute("aria-current", "true"));
        }
        _updateInterval() {
            const t = this._activeElement || this._getActive();
            if (!t) return;
            const e = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
            this._config.interval = e || this._config.defaultInterval;
        }
        _slide(t, e = null) {
            if (this._isSliding) return;
            const i = this._getActive(), s = t === ut, n = e || w(this._getItems(), i, s, this._config.wrap);
            if (n === i) return;
            const o = this._getItemIndex(n), r = (e)=>j.trigger(this._element, e, {
                    relatedTarget: n,
                    direction: this._orderToDirection(t),
                    from: this._getItemIndex(i),
                    to: o
                });
            if (r(mt).defaultPrevented) return;
            if (!i || !n) return;
            const a = Boolean(this._interval);
            this.pause(), this._isSliding = !0, this._setActiveIndicatorElement(o), this._activeElement = n;
            const l = s ? "carousel-item-start" : "carousel-item-end", c = s ? "carousel-item-next" : "carousel-item-prev";
            n.classList.add(c), g(n), i.classList.add(l), n.classList.add(l), this._queueCallback(()=>{
                n.classList.remove(l, c), n.classList.add(Tt), i.classList.remove(Tt, c, l), this._isSliding = !1, r(pt);
            }, i, this._isAnimated()), a && this.cycle();
        }
        _isAnimated() {
            return this._element.classList.contains("slide");
        }
        _getActive() {
            return K.findOne(St, this._element);
        }
        _getItems() {
            return K.find($t, this._element);
        }
        _clearInterval() {
            this._interval && (clearInterval(this._interval), this._interval = null);
        }
        _directionToOrder(t) {
            return p() ? t === gt ? _t : ut : t === gt ? ut : _t;
        }
        _orderToDirection(t) {
            return p() ? t === _t ? gt : ft : t === _t ? ft : gt;
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Dt.getOrCreateInstance(this, t);
                if ("number" != typeof t) {
                    if ("string" == typeof t) {
                        if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                        e[t]();
                    }
                } else e.to(t);
            });
        }
    }
    j.on(document, Et, "[data-bs-slide], [data-bs-slide-to]", function(t) {
        const e = K.getElementFromSelector(this);
        if (!e || !e.classList.contains(Ct)) return;
        t.preventDefault();
        const i = Dt.getOrCreateInstance(e), s = this.getAttribute("data-bs-slide-to");
        return s ? (i.to(s), void i._maybeEnableCycle()) : "next" === B.getDataAttribute(this, "slide") ? (i.next(), void i._maybeEnableCycle()) : (i.prev(), void i._maybeEnableCycle());
    }), j.on(window, At, ()=>{
        const t = K.find('[data-bs-ride="carousel"]');
        for (const e of t)Dt.getOrCreateInstance(e);
    }), b(Dt);
    const Nt = ".bs.collapse", Pt = `show${Nt}`, xt = `shown${Nt}`, Mt = `hide${Nt}`, jt = `hidden${Nt}`, Ft = `click${Nt}.data-api`, zt = "show", Ht = "collapse", Bt = "collapsing", qt = `:scope .${Ht} .${Ht}`, Wt = '[data-bs-toggle="collapse"]', Rt = {
        parent: null,
        toggle: !0
    }, Kt = {
        parent: "(null|element)",
        toggle: "boolean"
    };
    class Vt extends W {
        constructor(t, e){
            super(t, e), this._isTransitioning = !1, this._triggerArray = [];
            const i = K.find(Wt);
            for (const t of i){
                const e = K.getSelectorFromElement(t), i = K.find(e).filter((t)=>t === this._element);
                null !== e && i.length && this._triggerArray.push(t);
            }
            this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
        }
        static get Default() {
            return Rt;
        }
        static get DefaultType() {
            return Kt;
        }
        static get NAME() {
            return "collapse";
        }
        toggle() {
            this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let t = [];
            if (this._config.parent && (t = this._getFirstLevelChildren(".collapse.show, .collapse.collapsing").filter((t)=>t !== this._element).map((t)=>Vt.getOrCreateInstance(t, {
                    toggle: !1
                }))), t.length && t[0]._isTransitioning) return;
            if (j.trigger(this._element, Pt).defaultPrevented) return;
            for (const e of t)e.hide();
            const e = this._getDimension();
            this._element.classList.remove(Ht), this._element.classList.add(Bt), this._element.style[e] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
            const i = `scroll${e[0].toUpperCase() + e.slice(1)}`;
            this._queueCallback(()=>{
                this._isTransitioning = !1, this._element.classList.remove(Bt), this._element.classList.add(Ht, zt), this._element.style[e] = "", j.trigger(this._element, xt);
            }, this._element, !0), this._element.style[e] = `${this._element[i]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            if (j.trigger(this._element, Mt).defaultPrevented) return;
            const t = this._getDimension();
            this._element.style[t] = `${this._element.getBoundingClientRect()[t]}px`, g(this._element), this._element.classList.add(Bt), this._element.classList.remove(Ht, zt);
            for (const t of this._triggerArray){
                const e = K.getElementFromSelector(t);
                e && !this._isShown(e) && this._addAriaAndCollapsedClass([
                    t
                ], !1);
            }
            this._isTransitioning = !0, this._element.style[t] = "", this._queueCallback(()=>{
                this._isTransitioning = !1, this._element.classList.remove(Bt), this._element.classList.add(Ht), j.trigger(this._element, jt);
            }, this._element, !0);
        }
        _isShown(t = this._element) {
            return t.classList.contains(zt);
        }
        _configAfterMerge(t) {
            return t.toggle = Boolean(t.toggle), t.parent = c(t.parent), t;
        }
        _getDimension() {
            return this._element.classList.contains("collapse-horizontal") ? "width" : "height";
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const t = this._getFirstLevelChildren(Wt);
            for (const e of t){
                const t = K.getElementFromSelector(e);
                t && this._addAriaAndCollapsedClass([
                    e
                ], this._isShown(t));
            }
        }
        _getFirstLevelChildren(t) {
            const e = K.find(qt, this._config.parent);
            return K.find(t, this._config.parent).filter((t)=>!e.includes(t));
        }
        _addAriaAndCollapsedClass(t, e) {
            if (t.length) for (const i of t)i.classList.toggle("collapsed", !e), i.setAttribute("aria-expanded", e);
        }
        static jQueryInterface(t) {
            const e = {};
            return "string" == typeof t && /show|hide/.test(t) && (e.toggle = !1), this.each(function() {
                const i = Vt.getOrCreateInstance(this, e);
                if ("string" == typeof t) {
                    if (void 0 === i[t]) throw new TypeError(`No method named "${t}"`);
                    i[t]();
                }
            });
        }
    }
    j.on(document, Ft, Wt, function(t) {
        ("A" === t.target.tagName || t.delegateTarget && "A" === t.delegateTarget.tagName) && t.preventDefault();
        for (const t of K.getMultipleElementsFromSelector(this))Vt.getOrCreateInstance(t, {
            toggle: !1
        }).toggle();
    }), b(Vt);
    const Qt = "dropdown", Xt = ".bs.dropdown", Yt = ".data-api", Ut = "ArrowUp", Gt = "ArrowDown", Jt = `hide${Xt}`, Zt = `hidden${Xt}`, te = `show${Xt}`, ee = `shown${Xt}`, ie = `click${Xt}${Yt}`, se = `keydown${Xt}${Yt}`, ne = `keyup${Xt}${Yt}`, oe = "show", re = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', ae = `${re}.${oe}`, le = ".dropdown-menu", ce = p() ? "top-end" : "top-start", he = p() ? "top-start" : "top-end", de = p() ? "bottom-end" : "bottom-start", ue = p() ? "bottom-start" : "bottom-end", _e = p() ? "left-start" : "right-start", ge = p() ? "right-start" : "left-start", fe = {
        autoClose: !0,
        boundary: "clippingParents",
        display: "dynamic",
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: "toggle"
    }, me = {
        autoClose: "(boolean|string)",
        boundary: "(string|element)",
        display: "string",
        offset: "(array|string|function)",
        popperConfig: "(null|object|function)",
        reference: "(string|element|object)"
    };
    class pe extends W {
        constructor(t, e){
            super(t, e), this._popper = null, this._parent = this._element.parentNode, this._menu = K.next(this._element, le)[0] || K.prev(this._element, le)[0] || K.findOne(le, this._parent), this._inNavbar = this._detectNavbar();
        }
        static get Default() {
            return fe;
        }
        static get DefaultType() {
            return me;
        }
        static get NAME() {
            return Qt;
        }
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (d(this._element) || this._isShown()) return;
            const t = {
                relatedTarget: this._element
            };
            if (!j.trigger(this._element, te, t).defaultPrevented) {
                if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(".navbar-nav")) for (const t of [].concat(...document.body.children))j.on(t, "mouseover", _);
                this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.add(oe), this._element.classList.add(oe), j.trigger(this._element, ee, t);
            }
        }
        hide() {
            if (d(this._element) || !this._isShown()) return;
            const t = {
                relatedTarget: this._element
            };
            this._completeHide(t);
        }
        dispose() {
            this._popper && this._popper.destroy(), super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
        }
        _completeHide(t) {
            if (!j.trigger(this._element, Jt, t).defaultPrevented) {
                if ("ontouchstart" in document.documentElement) for (const t of [].concat(...document.body.children))j.off(t, "mouseover", _);
                this._popper && this._popper.destroy(), this._menu.classList.remove(oe), this._element.classList.remove(oe), this._element.setAttribute("aria-expanded", "false"), B.removeDataAttribute(this._menu, "popper"), j.trigger(this._element, Zt, t), this._element.focus();
            }
        }
        _getConfig(t) {
            if ("object" == typeof (t = super._getConfig(t)).reference && !l(t.reference) && "function" != typeof t.reference.getBoundingClientRect) throw new TypeError(`${Qt.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return t;
        }
        _createPopper() {
            if (void 0 === i) throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");
            let t = this._element;
            "parent" === this._config.reference ? t = this._parent : l(this._config.reference) ? t = c(this._config.reference) : "object" == typeof this._config.reference && (t = this._config.reference);
            const e = this._getPopperConfig();
            this._popper = i.createPopper(t, this._menu, e);
        }
        _isShown() {
            return this._menu.classList.contains(oe);
        }
        _getPlacement() {
            const t = this._parent;
            if (t.classList.contains("dropend")) return _e;
            if (t.classList.contains("dropstart")) return ge;
            if (t.classList.contains("dropup-center")) return "top";
            if (t.classList.contains("dropdown-center")) return "bottom";
            const e = "end" === getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();
            return t.classList.contains("dropup") ? e ? he : ce : e ? ue : de;
        }
        _detectNavbar() {
            return null !== this._element.closest(".navbar");
        }
        _getOffset() {
            const { offset: t } = this._config;
            return "string" == typeof t ? t.split(",").map((t)=>Number.parseInt(t, 10)) : "function" == typeof t ? (e)=>t(e, this._element) : t;
        }
        _getPopperConfig() {
            const t = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            };
            return (this._inNavbar || "static" === this._config.display) && (B.setDataAttribute(this._menu, "popper", "static"), t.modifiers = [
                {
                    name: "applyStyles",
                    enabled: !1
                }
            ]), {
                ...t,
                ...v(this._config.popperConfig, [
                    void 0,
                    t
                ])
            };
        }
        _selectMenuItem({ key: t, target: e }) {
            const i = K.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", this._menu).filter((t)=>h(t));
            i.length && w(i, e, t === Gt, !i.includes(e)).focus();
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = pe.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
        static clearMenus(t) {
            if (2 === t.button || "keyup" === t.type && "Tab" !== t.key) return;
            const e = K.find(ae);
            for (const i of e){
                const e = pe.getInstance(i);
                if (!e || !1 === e._config.autoClose) continue;
                const s = t.composedPath(), n = s.includes(e._menu);
                if (s.includes(e._element) || "inside" === e._config.autoClose && !n || "outside" === e._config.autoClose && n) continue;
                if (e._menu.contains(t.target) && ("keyup" === t.type && "Tab" === t.key || /input|select|option|textarea|form/i.test(t.target.tagName))) continue;
                const o = {
                    relatedTarget: e._element
                };
                "click" === t.type && (o.clickEvent = t), e._completeHide(o);
            }
        }
        static dataApiKeydownHandler(t) {
            const e = /input|textarea/i.test(t.target.tagName), i = "Escape" === t.key, s = [
                Ut,
                Gt
            ].includes(t.key);
            if (!s && !i) return;
            if (e && !i) return;
            t.preventDefault();
            const n = this.matches(re) ? this : K.prev(this, re)[0] || K.next(this, re)[0] || K.findOne(re, t.delegateTarget.parentNode), o = pe.getOrCreateInstance(n);
            if (s) return t.stopPropagation(), o.show(), void o._selectMenuItem(t);
            o._isShown() && (t.stopPropagation(), o.hide(), n.focus());
        }
    }
    j.on(document, se, re, pe.dataApiKeydownHandler), j.on(document, se, le, pe.dataApiKeydownHandler), j.on(document, ie, pe.clearMenus), j.on(document, ne, pe.clearMenus), j.on(document, ie, re, function(t) {
        t.preventDefault(), pe.getOrCreateInstance(this).toggle();
    }), b(pe);
    const be = "backdrop", ve = "show", ye = `mousedown.bs.${be}`, we = {
        className: "modal-backdrop",
        clickCallback: null,
        isAnimated: !1,
        isVisible: !0,
        rootElement: "body"
    }, Ae = {
        className: "string",
        clickCallback: "(function|null)",
        isAnimated: "boolean",
        isVisible: "boolean",
        rootElement: "(element|string)"
    };
    class Ee extends q {
        constructor(t){
            super(), this._config = this._getConfig(t), this._isAppended = !1, this._element = null;
        }
        static get Default() {
            return we;
        }
        static get DefaultType() {
            return Ae;
        }
        static get NAME() {
            return be;
        }
        show(t) {
            if (!this._config.isVisible) return void v(t);
            this._append();
            const e = this._getElement();
            this._config.isAnimated && g(e), e.classList.add(ve), this._emulateAnimation(()=>{
                v(t);
            });
        }
        hide(t) {
            this._config.isVisible ? (this._getElement().classList.remove(ve), this._emulateAnimation(()=>{
                this.dispose(), v(t);
            })) : v(t);
        }
        dispose() {
            this._isAppended && (j.off(this._element, ye), this._element.remove(), this._isAppended = !1);
        }
        _getElement() {
            if (!this._element) {
                const t = document.createElement("div");
                t.className = this._config.className, this._config.isAnimated && t.classList.add("fade"), this._element = t;
            }
            return this._element;
        }
        _configAfterMerge(t) {
            return t.rootElement = c(t.rootElement), t;
        }
        _append() {
            if (this._isAppended) return;
            const t = this._getElement();
            this._config.rootElement.append(t), j.on(t, ye, ()=>{
                v(this._config.clickCallback);
            }), this._isAppended = !0;
        }
        _emulateAnimation(t) {
            y(t, this._getElement(), this._config.isAnimated);
        }
    }
    const Ce = ".bs.focustrap", Te = `focusin${Ce}`, ke = `keydown.tab${Ce}`, $e = "backward", Se = {
        autofocus: !0,
        trapElement: null
    }, Le = {
        autofocus: "boolean",
        trapElement: "element"
    };
    class Oe extends q {
        constructor(t){
            super(), this._config = this._getConfig(t), this._isActive = !1, this._lastTabNavDirection = null;
        }
        static get Default() {
            return Se;
        }
        static get DefaultType() {
            return Le;
        }
        static get NAME() {
            return "focustrap";
        }
        activate() {
            this._isActive || (this._config.autofocus && this._config.trapElement.focus(), j.off(document, Ce), j.on(document, Te, (t)=>this._handleFocusin(t)), j.on(document, ke, (t)=>this._handleKeydown(t)), this._isActive = !0);
        }
        deactivate() {
            this._isActive && (this._isActive = !1, j.off(document, Ce));
        }
        _handleFocusin(t) {
            const { trapElement: e } = this._config;
            if (t.target === document || t.target === e || e.contains(t.target)) return;
            const i = K.focusableChildren(e);
            0 === i.length ? e.focus() : this._lastTabNavDirection === $e ? i[i.length - 1].focus() : i[0].focus();
        }
        _handleKeydown(t) {
            "Tab" === t.key && (this._lastTabNavDirection = t.shiftKey ? $e : "forward");
        }
    }
    const Ie = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", De = ".sticky-top", Ne = "padding-right", Pe = "margin-right";
    class xe {
        constructor(){
            this._element = document.body;
        }
        getWidth() {
            const t = document.documentElement.clientWidth;
            return Math.abs(window.innerWidth - t);
        }
        hide() {
            const t = this.getWidth();
            this._disableOverFlow(), this._setElementAttributes(this._element, Ne, (e)=>e + t), this._setElementAttributes(Ie, Ne, (e)=>e + t), this._setElementAttributes(De, Pe, (e)=>e - t);
        }
        reset() {
            this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, Ne), this._resetElementAttributes(Ie, Ne), this._resetElementAttributes(De, Pe);
        }
        isOverflowing() {
            return this.getWidth() > 0;
        }
        _disableOverFlow() {
            this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
        }
        _setElementAttributes(t, e, i) {
            const s = this.getWidth();
            this._applyManipulationCallback(t, (t)=>{
                if (t !== this._element && window.innerWidth > t.clientWidth + s) return;
                this._saveInitialAttribute(t, e);
                const n = window.getComputedStyle(t).getPropertyValue(e);
                t.style.setProperty(e, `${i(Number.parseFloat(n))}px`);
            });
        }
        _saveInitialAttribute(t, e) {
            const i = t.style.getPropertyValue(e);
            i && B.setDataAttribute(t, e, i);
        }
        _resetElementAttributes(t, e) {
            this._applyManipulationCallback(t, (t)=>{
                const i = B.getDataAttribute(t, e);
                null !== i ? (B.removeDataAttribute(t, e), t.style.setProperty(e, i)) : t.style.removeProperty(e);
            });
        }
        _applyManipulationCallback(t, e) {
            if (l(t)) e(t);
            else for (const i of K.find(t, this._element))e(i);
        }
    }
    const Me = ".bs.modal", je = `hide${Me}`, Fe = `hidePrevented${Me}`, ze = `hidden${Me}`, He = `show${Me}`, Be = `shown${Me}`, qe = `resize${Me}`, We = `click.dismiss${Me}`, Re = `mousedown.dismiss${Me}`, Ke = `keydown.dismiss${Me}`, Ve = `click${Me}.data-api`, Qe = "modal-open", Xe = "show", Ye = "modal-static", Ue = {
        backdrop: !0,
        focus: !0,
        keyboard: !0
    }, Ge = {
        backdrop: "(boolean|string)",
        focus: "boolean",
        keyboard: "boolean"
    };
    class Je extends W {
        constructor(t, e){
            super(t, e), this._dialog = K.findOne(".modal-dialog", this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new xe, this._addEventListeners();
        }
        static get Default() {
            return Ue;
        }
        static get DefaultType() {
            return Ge;
        }
        static get NAME() {
            return "modal";
        }
        toggle(t) {
            return this._isShown ? this.hide() : this.show(t);
        }
        show(t) {
            this._isShown || this._isTransitioning || j.trigger(this._element, He, {
                relatedTarget: t
            }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(Qe), this._adjustDialog(), this._backdrop.show(()=>this._showElement(t)));
        }
        hide() {
            this._isShown && !this._isTransitioning && (j.trigger(this._element, je).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(Xe), this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated())));
        }
        dispose() {
            j.off(window, Me), j.off(this._dialog, Me), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
        }
        handleUpdate() {
            this._adjustDialog();
        }
        _initializeBackDrop() {
            return new Ee({
                isVisible: Boolean(this._config.backdrop),
                isAnimated: this._isAnimated()
            });
        }
        _initializeFocusTrap() {
            return new Oe({
                trapElement: this._element
            });
        }
        _showElement(t) {
            document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
            const e = K.findOne(".modal-body", this._dialog);
            e && (e.scrollTop = 0), g(this._element), this._element.classList.add(Xe), this._queueCallback(()=>{
                this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, j.trigger(this._element, Be, {
                    relatedTarget: t
                });
            }, this._dialog, this._isAnimated());
        }
        _addEventListeners() {
            j.on(this._element, Ke, (t)=>{
                "Escape" === t.key && (this._config.keyboard ? this.hide() : this._triggerBackdropTransition());
            }), j.on(window, qe, ()=>{
                this._isShown && !this._isTransitioning && this._adjustDialog();
            }), j.on(this._element, Re, (t)=>{
                j.one(this._element, We, (e)=>{
                    this._element === t.target && this._element === e.target && ("static" !== this._config.backdrop ? this._config.backdrop && this.hide() : this._triggerBackdropTransition());
                });
            });
        }
        _hideModal() {
            this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(()=>{
                document.body.classList.remove(Qe), this._resetAdjustments(), this._scrollBar.reset(), j.trigger(this._element, ze);
            });
        }
        _isAnimated() {
            return this._element.classList.contains("fade");
        }
        _triggerBackdropTransition() {
            if (j.trigger(this._element, Fe).defaultPrevented) return;
            const t = this._element.scrollHeight > document.documentElement.clientHeight, e = this._element.style.overflowY;
            "hidden" === e || this._element.classList.contains(Ye) || (t || (this._element.style.overflowY = "hidden"), this._element.classList.add(Ye), this._queueCallback(()=>{
                this._element.classList.remove(Ye), this._queueCallback(()=>{
                    this._element.style.overflowY = e;
                }, this._dialog);
            }, this._dialog), this._element.focus());
        }
        _adjustDialog() {
            const t = this._element.scrollHeight > document.documentElement.clientHeight, e = this._scrollBar.getWidth(), i = e > 0;
            if (i && !t) {
                const t = p() ? "paddingLeft" : "paddingRight";
                this._element.style[t] = `${e}px`;
            }
            if (!i && t) {
                const t = p() ? "paddingRight" : "paddingLeft";
                this._element.style[t] = `${e}px`;
            }
        }
        _resetAdjustments() {
            this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
        }
        static jQueryInterface(t, e) {
            return this.each(function() {
                const i = Je.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === i[t]) throw new TypeError(`No method named "${t}"`);
                    i[t](e);
                }
            });
        }
    }
    j.on(document, Ve, '[data-bs-toggle="modal"]', function(t) {
        const e = K.getElementFromSelector(this);
        [
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), j.one(e, He, (t)=>{
            t.defaultPrevented || j.one(e, ze, ()=>{
                h(this) && this.focus();
            });
        });
        const i = K.findOne(".modal.show");
        i && Je.getInstance(i).hide(), Je.getOrCreateInstance(e).toggle(this);
    }), V(Je), b(Je);
    const Ze = ".bs.offcanvas", ti = ".data-api", ei = `load${Ze}${ti}`, ii = "show", si = "showing", ni = "hiding", oi = ".offcanvas.show", ri = `show${Ze}`, ai = `shown${Ze}`, li = `hide${Ze}`, ci = `hidePrevented${Ze}`, hi = `hidden${Ze}`, di = `resize${Ze}`, ui = `click${Ze}${ti}`, _i = `keydown.dismiss${Ze}`, gi = {
        backdrop: !0,
        keyboard: !0,
        scroll: !1
    }, fi = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        scroll: "boolean"
    };
    class mi extends W {
        constructor(t, e){
            super(t, e), this._isShown = !1, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
        }
        static get Default() {
            return gi;
        }
        static get DefaultType() {
            return fi;
        }
        static get NAME() {
            return "offcanvas";
        }
        toggle(t) {
            return this._isShown ? this.hide() : this.show(t);
        }
        show(t) {
            this._isShown || j.trigger(this._element, ri, {
                relatedTarget: t
            }).defaultPrevented || (this._isShown = !0, this._backdrop.show(), this._config.scroll || (new xe).hide(), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(si), this._queueCallback(()=>{
                this._config.scroll && !this._config.backdrop || this._focustrap.activate(), this._element.classList.add(ii), this._element.classList.remove(si), j.trigger(this._element, ai, {
                    relatedTarget: t
                });
            }, this._element, !0));
        }
        hide() {
            this._isShown && (j.trigger(this._element, li).defaultPrevented || (this._focustrap.deactivate(), this._element.blur(), this._isShown = !1, this._element.classList.add(ni), this._backdrop.hide(), this._queueCallback(()=>{
                this._element.classList.remove(ii, ni), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || (new xe).reset(), j.trigger(this._element, hi);
            }, this._element, !0)));
        }
        dispose() {
            this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
        }
        _initializeBackDrop() {
            const t = Boolean(this._config.backdrop);
            return new Ee({
                className: "offcanvas-backdrop",
                isVisible: t,
                isAnimated: !0,
                rootElement: this._element.parentNode,
                clickCallback: t ? ()=>{
                    "static" !== this._config.backdrop ? this.hide() : j.trigger(this._element, ci);
                } : null
            });
        }
        _initializeFocusTrap() {
            return new Oe({
                trapElement: this._element
            });
        }
        _addEventListeners() {
            j.on(this._element, _i, (t)=>{
                "Escape" === t.key && (this._config.keyboard ? this.hide() : j.trigger(this._element, ci));
            });
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = mi.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t](this);
                }
            });
        }
    }
    j.on(document, ui, '[data-bs-toggle="offcanvas"]', function(t) {
        const e = K.getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), d(this)) return;
        j.one(e, hi, ()=>{
            h(this) && this.focus();
        });
        const i = K.findOne(oi);
        i && i !== e && mi.getInstance(i).hide(), mi.getOrCreateInstance(e).toggle(this);
    }), j.on(window, ei, ()=>{
        for (const t of K.find(oi))mi.getOrCreateInstance(t).show();
    }), j.on(window, di, ()=>{
        for (const t of K.find("[aria-modal][class*=show][class*=offcanvas-]"))"fixed" !== getComputedStyle(t).position && mi.getOrCreateInstance(t).hide();
    }), V(mi), b(mi);
    const pi = {
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            /^aria-[\w-]*$/i
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    }, bi = new Set([
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ]), vi = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, yi = (t, e)=>{
        const i = t.nodeName.toLowerCase();
        return e.includes(i) ? !bi.has(i) || Boolean(vi.test(t.nodeValue)) : e.filter((t)=>t instanceof RegExp).some((t)=>t.test(i));
    }, wi = {
        allowList: pi,
        content: {},
        extraClass: "",
        html: !1,
        sanitize: !0,
        sanitizeFn: null,
        template: "<div></div>"
    }, Ai = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
    }, Ei = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
    };
    class Ci extends q {
        constructor(t){
            super(), this._config = this._getConfig(t);
        }
        static get Default() {
            return wi;
        }
        static get DefaultType() {
            return Ai;
        }
        static get NAME() {
            return "TemplateFactory";
        }
        getContent() {
            return Object.values(this._config.content).map((t)=>this._resolvePossibleFunction(t)).filter(Boolean);
        }
        hasContent() {
            return this.getContent().length > 0;
        }
        changeContent(t) {
            return this._checkContent(t), this._config.content = {
                ...this._config.content,
                ...t
            }, this;
        }
        toHtml() {
            const t = document.createElement("div");
            t.innerHTML = this._maybeSanitize(this._config.template);
            for (const [e, i] of Object.entries(this._config.content))this._setContent(t, i, e);
            const e = t.children[0], i = this._resolvePossibleFunction(this._config.extraClass);
            return i && e.classList.add(...i.split(" ")), e;
        }
        _typeCheckConfig(t) {
            super._typeCheckConfig(t), this._checkContent(t.content);
        }
        _checkContent(t) {
            for (const [e, i] of Object.entries(t))super._typeCheckConfig({
                selector: e,
                entry: i
            }, Ei);
        }
        _setContent(t, e, i) {
            const s = K.findOne(i, t);
            s && ((e = this._resolvePossibleFunction(e)) ? l(e) ? this._putElementInTemplate(c(e), s) : this._config.html ? s.innerHTML = this._maybeSanitize(e) : s.textContent = e : s.remove());
        }
        _maybeSanitize(t) {
            return this._config.sanitize ? function(t, e, i) {
                if (!t.length) return t;
                if (i && "function" == typeof i) return i(t);
                const s = (new window.DOMParser).parseFromString(t, "text/html"), n = [].concat(...s.body.querySelectorAll("*"));
                for (const t of n){
                    const i = t.nodeName.toLowerCase();
                    if (!Object.keys(e).includes(i)) {
                        t.remove();
                        continue;
                    }
                    const s = [].concat(...t.attributes), n = [].concat(e["*"] || [], e[i] || []);
                    for (const e of s)yi(e, n) || t.removeAttribute(e.nodeName);
                }
                return s.body.innerHTML;
            }(t, this._config.allowList, this._config.sanitizeFn) : t;
        }
        _resolvePossibleFunction(t) {
            return v(t, [
                void 0,
                this
            ]);
        }
        _putElementInTemplate(t, e) {
            if (this._config.html) return e.innerHTML = "", void e.append(t);
            e.textContent = t.textContent;
        }
    }
    const Ti = new Set([
        "sanitize",
        "allowList",
        "sanitizeFn"
    ]), ki = "fade", $i = "show", Si = ".tooltip-inner", Li = ".modal", Oi = "hide.bs.modal", Ii = "hover", Di = "focus", Ni = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: p() ? "left" : "right",
        BOTTOM: "bottom",
        LEFT: p() ? "right" : "left"
    }, Pi = {
        allowList: pi,
        animation: !0,
        boundary: "clippingParents",
        container: !1,
        customClass: "",
        delay: 0,
        fallbackPlacements: [
            "top",
            "right",
            "bottom",
            "left"
        ],
        html: !1,
        offset: [
            0,
            6
        ],
        placement: "top",
        popperConfig: null,
        sanitize: !0,
        sanitizeFn: null,
        selector: !1,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: "",
        trigger: "hover focus"
    }, xi = {
        allowList: "object",
        animation: "boolean",
        boundary: "(string|element)",
        container: "(string|element|boolean)",
        customClass: "(string|function)",
        delay: "(number|object)",
        fallbackPlacements: "array",
        html: "boolean",
        offset: "(array|string|function)",
        placement: "(string|function)",
        popperConfig: "(null|object|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        selector: "(string|boolean)",
        template: "string",
        title: "(string|element|function)",
        trigger: "string"
    };
    class Mi extends W {
        constructor(t, e){
            if (void 0 === i) throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");
            super(t, e), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
        }
        static get Default() {
            return Pi;
        }
        static get DefaultType() {
            return xi;
        }
        static get NAME() {
            return "tooltip";
        }
        enable() {
            this._isEnabled = !0;
        }
        disable() {
            this._isEnabled = !1;
        }
        toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        }
        toggle() {
            this._isEnabled && (this._isShown() ? this._leave() : this._enter());
        }
        dispose() {
            clearTimeout(this._timeout), j.off(this._element.closest(Li), Oi, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
        }
        show() {
            if ("none" === this._element.style.display) throw new Error("Please use show on visible elements");
            if (!this._isWithContent() || !this._isEnabled) return;
            const t = j.trigger(this._element, this.constructor.eventName("show")), e = (u(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
            if (t.defaultPrevented || !e) return;
            this._disposePopper();
            const i = this._getTipElement();
            this._element.setAttribute("aria-describedby", i.getAttribute("id"));
            const { container: s } = this._config;
            if (this._element.ownerDocument.documentElement.contains(this.tip) || (s.append(i), j.trigger(this._element, this.constructor.eventName("inserted"))), this._popper = this._createPopper(i), i.classList.add($i), "ontouchstart" in document.documentElement) for (const t of [].concat(...document.body.children))j.on(t, "mouseover", _);
            this._queueCallback(()=>{
                j.trigger(this._element, this.constructor.eventName("shown")), !1 === this._isHovered && this._leave(), this._isHovered = !1;
            }, this.tip, this._isAnimated());
        }
        hide() {
            if (this._isShown() && !j.trigger(this._element, this.constructor.eventName("hide")).defaultPrevented) {
                if (this._getTipElement().classList.remove($i), "ontouchstart" in document.documentElement) for (const t of [].concat(...document.body.children))j.off(t, "mouseover", _);
                this._activeTrigger.click = !1, this._activeTrigger[Di] = !1, this._activeTrigger[Ii] = !1, this._isHovered = null, this._queueCallback(()=>{
                    this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), j.trigger(this._element, this.constructor.eventName("hidden")));
                }, this.tip, this._isAnimated());
            }
        }
        update() {
            this._popper && this._popper.update();
        }
        _isWithContent() {
            return Boolean(this._getTitle());
        }
        _getTipElement() {
            return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
        }
        _createTipElement(t) {
            const e = this._getTemplateFactory(t).toHtml();
            if (!e) return null;
            e.classList.remove(ki, $i), e.classList.add(`bs-${this.constructor.NAME}-auto`);
            const i = ((t)=>{
                do t += Math.floor(1e6 * Math.random());
                while (document.getElementById(t));
                return t;
            })(this.constructor.NAME).toString();
            return e.setAttribute("id", i), this._isAnimated() && e.classList.add(ki), e;
        }
        setContent(t) {
            this._newContent = t, this._isShown() && (this._disposePopper(), this.show());
        }
        _getTemplateFactory(t) {
            return this._templateFactory ? this._templateFactory.changeContent(t) : this._templateFactory = new Ci({
                ...this._config,
                content: t,
                extraClass: this._resolvePossibleFunction(this._config.customClass)
            }), this._templateFactory;
        }
        _getContentForTemplate() {
            return {
                [Si]: this._getTitle()
            };
        }
        _getTitle() {
            return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
        }
        _initializeOnDelegatedTarget(t) {
            return this.constructor.getOrCreateInstance(t.delegateTarget, this._getDelegateConfig());
        }
        _isAnimated() {
            return this._config.animation || this.tip && this.tip.classList.contains(ki);
        }
        _isShown() {
            return this.tip && this.tip.classList.contains($i);
        }
        _createPopper(t) {
            const e = v(this._config.placement, [
                this,
                t,
                this._element
            ]), s = Ni[e.toUpperCase()];
            return i.createPopper(this._element, t, this._getPopperConfig(s));
        }
        _getOffset() {
            const { offset: t } = this._config;
            return "string" == typeof t ? t.split(",").map((t)=>Number.parseInt(t, 10)) : "function" == typeof t ? (e)=>t(e, this._element) : t;
        }
        _resolvePossibleFunction(t) {
            return v(t, [
                this._element,
                this._element
            ]);
        }
        _getPopperConfig(t) {
            const e = {
                placement: t,
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            fallbackPlacements: this._config.fallbackPlacements
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "arrow",
                        options: {
                            element: `.${this.constructor.NAME}-arrow`
                        }
                    },
                    {
                        name: "preSetPlacement",
                        enabled: !0,
                        phase: "beforeMain",
                        fn: (t)=>{
                            this._getTipElement().setAttribute("data-popper-placement", t.state.placement);
                        }
                    }
                ]
            };
            return {
                ...e,
                ...v(this._config.popperConfig, [
                    void 0,
                    e
                ])
            };
        }
        _setListeners() {
            const t = this._config.trigger.split(" ");
            for (const e of t)if ("click" === e) j.on(this._element, this.constructor.eventName("click"), this._config.selector, (t)=>{
                this._initializeOnDelegatedTarget(t).toggle();
            });
            else if ("manual" !== e) {
                const t = e === Ii ? this.constructor.eventName("mouseenter") : this.constructor.eventName("focusin"), i = e === Ii ? this.constructor.eventName("mouseleave") : this.constructor.eventName("focusout");
                j.on(this._element, t, this._config.selector, (t)=>{
                    const e = this._initializeOnDelegatedTarget(t);
                    e._activeTrigger["focusin" === t.type ? Di : Ii] = !0, e._enter();
                }), j.on(this._element, i, this._config.selector, (t)=>{
                    const e = this._initializeOnDelegatedTarget(t);
                    e._activeTrigger["focusout" === t.type ? Di : Ii] = e._element.contains(t.relatedTarget), e._leave();
                });
            }
            this._hideModalHandler = ()=>{
                this._element && this.hide();
            }, j.on(this._element.closest(Li), Oi, this._hideModalHandler);
        }
        _fixTitle() {
            const t = this._element.getAttribute("title");
            t && (this._element.getAttribute("aria-label") || this._element.textContent.trim() || this._element.setAttribute("aria-label", t), this._element.setAttribute("data-bs-original-title", t), this._element.removeAttribute("title"));
        }
        _enter() {
            this._isShown() || this._isHovered ? this._isHovered = !0 : (this._isHovered = !0, this._setTimeout(()=>{
                this._isHovered && this.show();
            }, this._config.delay.show));
        }
        _leave() {
            this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(()=>{
                this._isHovered || this.hide();
            }, this._config.delay.hide));
        }
        _setTimeout(t, e) {
            clearTimeout(this._timeout), this._timeout = setTimeout(t, e);
        }
        _isWithActiveTrigger() {
            return Object.values(this._activeTrigger).includes(!0);
        }
        _getConfig(t) {
            const e = B.getDataAttributes(this._element);
            for (const t of Object.keys(e))Ti.has(t) && delete e[t];
            return t = {
                ...e,
                ..."object" == typeof t && t ? t : {}
            }, t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
        }
        _configAfterMerge(t) {
            return t.container = !1 === t.container ? document.body : c(t.container), "number" == typeof t.delay && (t.delay = {
                show: t.delay,
                hide: t.delay
            }), "number" == typeof t.title && (t.title = t.title.toString()), "number" == typeof t.content && (t.content = t.content.toString()), t;
        }
        _getDelegateConfig() {
            const t = {};
            for (const [e, i] of Object.entries(this._config))this.constructor.Default[e] !== i && (t[e] = i);
            return t.selector = !1, t.trigger = "manual", t;
        }
        _disposePopper() {
            this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Mi.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
    }
    b(Mi);
    const ji = ".popover-header", Fi = ".popover-body", zi = {
        ...Mi.Default,
        content: "",
        offset: [
            0,
            8
        ],
        placement: "right",
        template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        trigger: "click"
    }, Hi = {
        ...Mi.DefaultType,
        content: "(null|string|element|function)"
    };
    class Bi extends Mi {
        static get Default() {
            return zi;
        }
        static get DefaultType() {
            return Hi;
        }
        static get NAME() {
            return "popover";
        }
        _isWithContent() {
            return this._getTitle() || this._getContent();
        }
        _getContentForTemplate() {
            return {
                [ji]: this._getTitle(),
                [Fi]: this._getContent()
            };
        }
        _getContent() {
            return this._resolvePossibleFunction(this._config.content);
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Bi.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
    }
    b(Bi);
    const qi = ".bs.scrollspy", Wi = `activate${qi}`, Ri = `click${qi}`, Ki = `load${qi}.data-api`, Vi = "active", Qi = "[href]", Xi = ".nav-link", Yi = `${Xi}, .nav-item > ${Xi}, .list-group-item`, Ui = {
        offset: null,
        rootMargin: "0px 0px -25%",
        smoothScroll: !1,
        target: null,
        threshold: [
            .1,
            .5,
            1
        ]
    }, Gi = {
        offset: "(number|null)",
        rootMargin: "string",
        smoothScroll: "boolean",
        target: "element",
        threshold: "array"
    };
    class Ji extends W {
        constructor(t, e){
            super(t, e), this._targetLinks = new Map, this._observableSections = new Map, this._rootElement = "visible" === getComputedStyle(this._element).overflowY ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = {
                visibleEntryTop: 0,
                parentScrollTop: 0
            }, this.refresh();
        }
        static get Default() {
            return Ui;
        }
        static get DefaultType() {
            return Gi;
        }
        static get NAME() {
            return "scrollspy";
        }
        refresh() {
            this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
            for (const t of this._observableSections.values())this._observer.observe(t);
        }
        dispose() {
            this._observer.disconnect(), super.dispose();
        }
        _configAfterMerge(t) {
            return t.target = c(t.target) || document.body, t.rootMargin = t.offset ? `${t.offset}px 0px -30%` : t.rootMargin, "string" == typeof t.threshold && (t.threshold = t.threshold.split(",").map((t)=>Number.parseFloat(t))), t;
        }
        _maybeEnableSmoothScroll() {
            this._config.smoothScroll && (j.off(this._config.target, Ri), j.on(this._config.target, Ri, Qi, (t)=>{
                const e = this._observableSections.get(t.target.hash);
                if (e) {
                    t.preventDefault();
                    const i = this._rootElement || window, s = e.offsetTop - this._element.offsetTop;
                    if (i.scrollTo) return void i.scrollTo({
                        top: s,
                        behavior: "smooth"
                    });
                    i.scrollTop = s;
                }
            }));
        }
        _getNewObserver() {
            const t = {
                root: this._rootElement,
                threshold: this._config.threshold,
                rootMargin: this._config.rootMargin
            };
            return new IntersectionObserver((t)=>this._observerCallback(t), t);
        }
        _observerCallback(t) {
            const e = (t)=>this._targetLinks.get(`#${t.target.id}`), i = (t)=>{
                this._previousScrollData.visibleEntryTop = t.target.offsetTop, this._process(e(t));
            }, s = (this._rootElement || document.documentElement).scrollTop, n = s >= this._previousScrollData.parentScrollTop;
            this._previousScrollData.parentScrollTop = s;
            for (const o of t){
                if (!o.isIntersecting) {
                    this._activeTarget = null, this._clearActiveClass(e(o));
                    continue;
                }
                const t = o.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                if (n && t) {
                    if (i(o), !s) return;
                } else n || t || i(o);
            }
        }
        _initializeTargetsAndObservables() {
            this._targetLinks = new Map, this._observableSections = new Map;
            const t = K.find(Qi, this._config.target);
            for (const e of t){
                if (!e.hash || d(e)) continue;
                const t = K.findOne(decodeURI(e.hash), this._element);
                h(t) && (this._targetLinks.set(decodeURI(e.hash), e), this._observableSections.set(e.hash, t));
            }
        }
        _process(t) {
            this._activeTarget !== t && (this._clearActiveClass(this._config.target), this._activeTarget = t, t.classList.add(Vi), this._activateParents(t), j.trigger(this._element, Wi, {
                relatedTarget: t
            }));
        }
        _activateParents(t) {
            if (t.classList.contains("dropdown-item")) K.findOne(".dropdown-toggle", t.closest(".dropdown")).classList.add(Vi);
            else for (const e of K.parents(t, ".nav, .list-group"))for (const t of K.prev(e, Yi))t.classList.add(Vi);
        }
        _clearActiveClass(t) {
            t.classList.remove(Vi);
            const e = K.find(`${Qi}.${Vi}`, t);
            for (const t of e)t.classList.remove(Vi);
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Ji.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
    }
    j.on(window, Ki, ()=>{
        for (const t of K.find('[data-bs-spy="scroll"]'))Ji.getOrCreateInstance(t);
    }), b(Ji);
    const Zi = ".bs.tab", ts = `hide${Zi}`, es = `hidden${Zi}`, is = `show${Zi}`, ss = `shown${Zi}`, ns = `click${Zi}`, os = `keydown${Zi}`, rs = `load${Zi}`, as = "ArrowLeft", ls = "ArrowRight", cs = "ArrowUp", hs = "ArrowDown", ds = "Home", us = "End", _s = "active", gs = "fade", fs = "show", ms = ".dropdown-toggle", ps = `:not(${ms})`, bs = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', vs = `.nav-link${ps}, .list-group-item${ps}, [role="tab"]${ps}, ${bs}`, ys = `.${_s}[data-bs-toggle="tab"], .${_s}[data-bs-toggle="pill"], .${_s}[data-bs-toggle="list"]`;
    class ws extends W {
        constructor(t){
            super(t), this._parent = this._element.closest('.list-group, .nav, [role="tablist"]'), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), j.on(this._element, os, (t)=>this._keydown(t)));
        }
        static get NAME() {
            return "tab";
        }
        show() {
            const t = this._element;
            if (this._elemIsActive(t)) return;
            const e = this._getActiveElem(), i = e ? j.trigger(e, ts, {
                relatedTarget: t
            }) : null;
            j.trigger(t, is, {
                relatedTarget: e
            }).defaultPrevented || i && i.defaultPrevented || (this._deactivate(e, t), this._activate(t, e));
        }
        _activate(t, e) {
            t && (t.classList.add(_s), this._activate(K.getElementFromSelector(t)), this._queueCallback(()=>{
                "tab" === t.getAttribute("role") ? (t.removeAttribute("tabindex"), t.setAttribute("aria-selected", !0), this._toggleDropDown(t, !0), j.trigger(t, ss, {
                    relatedTarget: e
                })) : t.classList.add(fs);
            }, t, t.classList.contains(gs)));
        }
        _deactivate(t, e) {
            t && (t.classList.remove(_s), t.blur(), this._deactivate(K.getElementFromSelector(t)), this._queueCallback(()=>{
                "tab" === t.getAttribute("role") ? (t.setAttribute("aria-selected", !1), t.setAttribute("tabindex", "-1"), this._toggleDropDown(t, !1), j.trigger(t, es, {
                    relatedTarget: e
                })) : t.classList.remove(fs);
            }, t, t.classList.contains(gs)));
        }
        _keydown(t) {
            if (![
                as,
                ls,
                cs,
                hs,
                ds,
                us
            ].includes(t.key)) return;
            t.stopPropagation(), t.preventDefault();
            const e = this._getChildren().filter((t)=>!d(t));
            let i;
            if ([
                ds,
                us
            ].includes(t.key)) i = e[t.key === ds ? 0 : e.length - 1];
            else {
                const s = [
                    ls,
                    hs
                ].includes(t.key);
                i = w(e, t.target, s, !0);
            }
            i && (i.focus({
                preventScroll: !0
            }), ws.getOrCreateInstance(i).show());
        }
        _getChildren() {
            return K.find(vs, this._parent);
        }
        _getActiveElem() {
            return this._getChildren().find((t)=>this._elemIsActive(t)) || null;
        }
        _setInitialAttributes(t, e) {
            this._setAttributeIfNotExists(t, "role", "tablist");
            for (const t of e)this._setInitialAttributesOnChild(t);
        }
        _setInitialAttributesOnChild(t) {
            t = this._getInnerElement(t);
            const e = this._elemIsActive(t), i = this._getOuterElement(t);
            t.setAttribute("aria-selected", e), i !== t && this._setAttributeIfNotExists(i, "role", "presentation"), e || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
        }
        _setInitialAttributesOnTargetPanel(t) {
            const e = K.getElementFromSelector(t);
            e && (this._setAttributeIfNotExists(e, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(e, "aria-labelledby", `${t.id}`));
        }
        _toggleDropDown(t, e) {
            const i = this._getOuterElement(t);
            if (!i.classList.contains("dropdown")) return;
            const s = (t, s)=>{
                const n = K.findOne(t, i);
                n && n.classList.toggle(s, e);
            };
            s(ms, _s), s(".dropdown-menu", fs), i.setAttribute("aria-expanded", e);
        }
        _setAttributeIfNotExists(t, e, i) {
            t.hasAttribute(e) || t.setAttribute(e, i);
        }
        _elemIsActive(t) {
            return t.classList.contains(_s);
        }
        _getInnerElement(t) {
            return t.matches(vs) ? t : K.findOne(vs, t);
        }
        _getOuterElement(t) {
            return t.closest(".nav-item, .list-group-item") || t;
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = ws.getOrCreateInstance(this);
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
    }
    j.on(document, ns, bs, function(t) {
        [
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), d(this) || ws.getOrCreateInstance(this).show();
    }), j.on(window, rs, ()=>{
        for (const t of K.find(ys))ws.getOrCreateInstance(t);
    }), b(ws);
    const As = ".bs.toast", Es = `mouseover${As}`, Cs = `mouseout${As}`, Ts = `focusin${As}`, ks = `focusout${As}`, $s = `hide${As}`, Ss = `hidden${As}`, Ls = `show${As}`, Os = `shown${As}`, Is = "hide", Ds = "show", Ns = "showing", Ps = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    }, xs = {
        animation: !0,
        autohide: !0,
        delay: 5e3
    };
    class Ms extends W {
        constructor(t, e){
            super(t, e), this._timeout = null, this._hasMouseInteraction = !1, this._hasKeyboardInteraction = !1, this._setListeners();
        }
        static get Default() {
            return xs;
        }
        static get DefaultType() {
            return Ps;
        }
        static get NAME() {
            return "toast";
        }
        show() {
            j.trigger(this._element, Ls).defaultPrevented || (this._clearTimeout(), this._config.animation && this._element.classList.add("fade"), this._element.classList.remove(Is), g(this._element), this._element.classList.add(Ds, Ns), this._queueCallback(()=>{
                this._element.classList.remove(Ns), j.trigger(this._element, Os), this._maybeScheduleHide();
            }, this._element, this._config.animation));
        }
        hide() {
            this.isShown() && (j.trigger(this._element, $s).defaultPrevented || (this._element.classList.add(Ns), this._queueCallback(()=>{
                this._element.classList.add(Is), this._element.classList.remove(Ns, Ds), j.trigger(this._element, Ss);
            }, this._element, this._config.animation)));
        }
        dispose() {
            this._clearTimeout(), this.isShown() && this._element.classList.remove(Ds), super.dispose();
        }
        isShown() {
            return this._element.classList.contains(Ds);
        }
        _maybeScheduleHide() {
            this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(()=>{
                this.hide();
            }, this._config.delay)));
        }
        _onInteraction(t, e) {
            switch(t.type){
                case "mouseover":
                case "mouseout":
                    this._hasMouseInteraction = e;
                    break;
                case "focusin":
                case "focusout":
                    this._hasKeyboardInteraction = e;
            }
            if (e) return void this._clearTimeout();
            const i = t.relatedTarget;
            this._element === i || this._element.contains(i) || this._maybeScheduleHide();
        }
        _setListeners() {
            j.on(this._element, Es, (t)=>this._onInteraction(t, !0)), j.on(this._element, Cs, (t)=>this._onInteraction(t, !1)), j.on(this._element, Ts, (t)=>this._onInteraction(t, !0)), j.on(this._element, ks, (t)=>this._onInteraction(t, !1));
        }
        _clearTimeout() {
            clearTimeout(this._timeout), this._timeout = null;
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Ms.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t](this);
                }
            });
        }
    }
    return V(Ms), b(Ms), {
        Alert: U,
        Button: J,
        Carousel: Dt,
        Collapse: Vt,
        Dropdown: pe,
        Modal: Je,
        Offcanvas: mi,
        Popover: Bi,
        ScrollSpy: Ji,
        Tab: ws,
        Toast: Ms,
        Tooltip: Mi
    };
});

})();
//# sourceMappingURL=build.889603f1.js.map
